export function getDateToday() {
    const today = new Date();
    return today.toISOString().slice(0, 10).replace(/-/g, ''); // "20260209"
}

// Utility to convert a unix timestamp (milliseconds since epoch) to a readable short format string
// Example output: '2026-02-10 13:45'
export function formatUnixTimestampShort(timestamp: number): string {
    const date = new Date(timestamp);
    // Format: YYYY-MM-DD HH:mm
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
